var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}]},[_c('rich-text-renderer',{attrs:{"document":_vm.blok.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }